import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetSupportList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_SUPPORT
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetSupportListAction(data.data));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetSupportList as SetGetSupportList
}